// Modal que muestra el replay narrado con IA del rango actual.
import { useState } from 'react'

const btnSecondary = {
  padding: '6px 12px', borderRadius: 5, fontSize: 11,
  background: 'rgba(255,255,255,0.1)', color: '#fff',
  border: '1px solid rgba(255,255,255,0.25)', cursor: 'pointer',
}

export default function NarrativeModal({ siteId, channel, start, end, token, onClose }) {
  const [audience, setAudience] = useState('operador')
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  const generate = async () => {
    setLoading(true); setError(null)
    try {
      const r = await fetch('/api/bookmarks/narrate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ site_id: siteId, channel, start, end, audience, include_detections: true }),
      })
      // Si el backend explota con HTML (Internal Server Error), .json() revienta.
      // Leemos texto crudo y parseamos seguro para que el error real sea visible.
      const raw = await r.text()
      let j = null
      try { j = JSON.parse(raw) } catch {}
      if (!r.ok) {
        const msg = j?.detail || raw.slice(0, 200) || `HTTP ${r.status}`
        throw new Error(`${r.status}: ${msg}`)
      }
      setResult(j)
    } catch (e) { setError(e.message) }
    setLoading(false)
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 200,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div onClick={e => e.stopPropagation()} style={{
        background: '#0a0a0a', color: '#fff', borderRadius: 10,
        border: '1.5px solid rgba(255,255,255,0.25)',
        padding: 18, minWidth: 600, maxWidth: 800, maxHeight: '85vh',
        overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.85)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700 }}>Replay narrado con IA</div>
            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
              {start} → {end} · canal {channel}
            </div>
          </div>
          <button onClick={onClose} style={{
            background: 'transparent', color: '#fff', border: 'none',
            cursor: 'pointer', fontSize: 18, padding: 0, width: 28, height: 28,
          }}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 14 }}>
          <span style={{ fontSize: 11, color: '#aaa' }}>Audiencia:</span>
          {['operador', 'gerente', 'legal'].map(a => (
            <label key={a} style={{ fontSize: 11, cursor: 'pointer' }}>
              <input type="radio" name="aud" value={a} checked={audience === a}
                onChange={e => setAudience(e.target.value)} style={{ marginRight: 4 }} />
              {a}
            </label>
          ))}
          <span style={{ flex: 1 }} />
          <button onClick={generate} disabled={loading} style={{
            padding: '8px 16px', borderRadius: 6, fontSize: 12, fontWeight: 700,
            background: loading ? '#444' : 'var(--accent)', color: '#fff',
            border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
          }}>{loading ? 'Generando…' : '▶ Generar narración'}</button>
        </div>

        {error && (
          <div style={{
            padding: 10, marginBottom: 10, borderRadius: 6,
            background: 'rgba(239,68,68,0.18)', color: '#fca5a5', fontSize: 11,
          }}>{error}</div>
        )}

        {result && (
          <div>
            <div style={{ fontSize: 10, color: '#888', marginBottom: 8 }}>
              {result.bookmarks_n} bookmark(s) · {result.detections_n} detección(es) consideradas
            </div>
            <div style={{
              fontSize: 13, lineHeight: 1.6, color: '#eee',
              background: '#0e0e0e', padding: 14, borderRadius: 8,
              border: '1px solid rgba(255,255,255,0.12)',
              whiteSpace: 'pre-wrap', fontFamily: 'ui-sans-serif, system-ui',
            }}>{result.narrative}</div>
            <div style={{ marginTop: 10, display: 'flex', gap: 6 }}>
              <button onClick={() => navigator.clipboard.writeText(result.narrative)}
                      style={btnSecondary}>Copiar texto</button>
              <button onClick={() => {
                const blob = new Blob([result.narrative], { type: 'text/markdown' })
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url; a.download = `replay_${siteId}_ch${channel}_${Date.now()}.md`
                document.body.appendChild(a); a.click()
                setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url) }, 1000)
              }} style={btnSecondary}>Descargar .md</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
